import { render, staticRenderFns } from "./CustomContent.vue?vue&type=template&id=6ae186ee&scoped=true&"
import script from "./CustomContent.vue?vue&type=script&lang=js&"
export * from "./CustomContent.vue?vue&type=script&lang=js&"
import style1 from "./CustomContent.vue?vue&type=style&index=1&id=6ae186ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae186ee",
  null
  
)

export default component.exports